<template>
  <div class="py-4 container-fluid laporan-container">
    <div class="row">
      <div class="col-lg-12">
        <h2 class="text-white mb-4 text-center font-weight-bold">
          <i class="ni ni-chart-bar-32 me-2"></i>Laporan Data Jemaat
        </h2>
        <!-- Year Filter Dropdown -->
        <div class="row mb-4">
          <div class="col-lg-12">
            <div class="card">
              <div class="p-3 card-body">
                <div class="row align-items-center">
                  <div class="col-md-12">
                    <label class="form-label font-weight-bold">Filter Tahun:</label>
                    <select
                      v-model="selectedYear"
                      @change="fetchLaporanData"
                      class="form-control"
                    >
                      <option
                        v-for="year in availableYears"
                        :key="year"
                        :value="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Jemaat Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Jemaat
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Jemaat"
                            :value="dataJemaat"
                            :percentage="getComparisonDisplay('dataJemaat', dataJemaat).percentage"
                            :percentageColor="getComparisonDisplay('dataJemaat', dataJemaat).percentageColor"
                            :detail="getComparisonDisplay('dataJemaat', dataJemaat).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Laki-Laki"
                            :value="dataJemaatL"
                            :percentage="getComparisonDisplay('dataJemaatL', dataJemaatL).percentage"
                            :percentageColor="getComparisonDisplay('dataJemaatL', dataJemaatL).percentageColor"
                            :detail="getComparisonDisplay('dataJemaatL', dataJemaatL).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Perempuan"
                            :value="dataJemaatP"
                            :percentage="getComparisonDisplay('dataJemaatP', dataJemaatP).percentage"
                            :percentageColor="getComparisonDisplay('dataJemaatP', dataJemaatP).percentageColor"
                            :detail="getComparisonDisplay('dataJemaatP', dataJemaatP).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Keluarga"
                            :value="dataKK"
                            :percentage="getComparisonDisplay('dataKK', dataKK).percentage"
                            :percentageColor="getComparisonDisplay('dataKK', dataKK).percentageColor"
                            :detail="getComparisonDisplay('dataKK', dataKK).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Titipan"
                            :value="dataTitipan"
                            :percentage="getComparisonDisplay('dataTitipan', dataTitipan).percentage"
                            :percentageColor="getComparisonDisplay('dataTitipan', dataTitipan).percentageColor"
                            :detail="getComparisonDisplay('dataTitipan', dataTitipan).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Jumlah Disabilitas"
                            :value="dataDisabilitas"
                            :percentage="getComparisonDisplay('dataDisabilitas', dataDisabilitas).percentage"
                            :percentageColor="getComparisonDisplay('dataDisabilitas', dataDisabilitas).percentageColor"
                            :detail="getComparisonDisplay('dataDisabilitas', dataDisabilitas).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Pindahan Ke Kristen"
                            :value="dataPindahanKeKristen"
                            :percentage="getComparisonDisplay('dataPindahanKeKristen', dataPindahanKeKristen).percentage"
                            :percentageColor="getComparisonDisplay('dataPindahanKeKristen', dataPindahanKeKristen).percentageColor"
                            :detail="getComparisonDisplay('dataPindahanKeKristen', dataPindahanKeKristen).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Pindahan Ke Non-Kristen"
                            :value="dataPindahanDariKristen"
                            :percentage="getComparisonDisplay('dataPindahanDariKristen', dataPindahanDariKristen).percentage"
                            :percentageColor="getComparisonDisplay('dataPindahanDariKristen', dataPindahanDariKristen).percentageColor"
                            :detail="getComparisonDisplay('dataPindahanDariKristen', dataPindahanDariKristen).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

        <!-- Data Wilayah Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Jemaat Per Wilayah
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3" v-for="(wilayah, index) in dataJumlahWilayah" :key="'wilayah-' + index">
                          <card
                            :title="wilayah.wilayah"
                            :value="wilayah.TOTAL || 0"
                            :percentage="getWilayahComparisonDisplay('dataJumlahWilayah', index).percentage"
                            :percentageColor="getWilayahComparisonDisplay('dataJumlahWilayah', index).percentageColor"
                            :detail="getWilayahComparisonDisplay('dataJumlahWilayah', index).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3" v-if="dataJumlahWilayahKosong > 0">
                          <card
                            title="Belum Terisi"
                            :value="dataJumlahWilayahKosong"
                            :percentage="getComparisonDisplay('dataJumlahWilayahKosong', dataJumlahWilayahKosong).percentage"
                            :percentageColor="getComparisonDisplay('dataJumlahWilayahKosong', dataJumlahWilayahKosong).percentageColor"
                            :detail="getComparisonDisplay('dataJumlahWilayahKosong', dataJumlahWilayahKosong).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Sektor Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Jemaat Per Sektor
                      </p>
                      <div class="row">                        
                        <div class="col-md-6 col-lg-4" v-for="(sektor, index) in dataJumlahSektor" :key="'sektor-' + index">
                          <card
                            :title="sektor.nama"
                            :value="sektor.TOTAL || 0"
                            :percentage="getSektorComparisonDisplay('dataJumlahSektor', index).percentage"
                            :percentageColor="getSektorComparisonDisplay('dataJumlahSektor', index).percentageColor"
                            :detail="getSektorComparisonDisplay('dataJumlahSektor', index).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4" v-if="dataJumlahSektorKosong > 0">
                          <card
                            title="Belum Terisi"
                            :value="dataJumlahSektorKosong"
                            :percentage="getComparisonDisplay('dataJumlahSektorKosong', dataJumlahSektorKosong).percentage"
                            :percentageColor="getComparisonDisplay('dataJumlahSektorKosong', dataJumlahSektorKosong).percentageColor"
                            :detail="getComparisonDisplay('dataJumlahSektorKosong', dataJumlahSektorKosong).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Keluarga Per Wilayah Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Keluarga Per Wilayah
                      </p>
                      <div class="row">                        <div class="col-md-6 col-lg-3" v-for="(wilayah, index) in dataJumlahKeluargaWilayah" :key="'keluarga-wilayah-' + index">
                          <card
                            :title="wilayah.wilayah"
                            :value="wilayah.TOTAL || 0"
                            :percentage="getWilayahComparisonDisplay('dataJumlahKeluargaWilayah', index).percentage"
                            :percentageColor="getWilayahComparisonDisplay('dataJumlahKeluargaWilayah', index).percentageColor"
                            :detail="getWilayahComparisonDisplay('dataJumlahKeluargaWilayah', index).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3" v-if="dataJumlahKeluargaWilayahKosong > 0">
                          <card
                            title="Belum Terisi"
                            :value="dataJumlahKeluargaWilayahKosong"
                            :percentage="getComparisonDisplay('dataJumlahKeluargaWilayahKosong', dataJumlahKeluargaWilayahKosong).percentage"
                            :percentageColor="getComparisonDisplay('dataJumlahKeluargaWilayahKosong', dataJumlahKeluargaWilayahKosong).percentageColor"
                            :detail="getComparisonDisplay('dataJumlahKeluargaWilayahKosong', dataJumlahKeluargaWilayahKosong).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Keluarga Per Sektor Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Keluarga Per Sektor
                      </p>
                      <div class="row">                        
                        <div class="col-md-6 col-lg-4" v-for="(sektor, index) in dataJumlahKeluargaSektor" :key="'keluarga-sektor-' + index">
                          <card
                            :title="sektor.nama"
                            :value="sektor.TOTAL || 0"
                            :percentage="getSektorComparisonDisplay('dataJumlahKeluargaSektor', index).percentage"
                            :percentageColor="getSektorComparisonDisplay('dataJumlahKeluargaSektor', index).percentageColor"
                            :detail="getSektorComparisonDisplay('dataJumlahKeluargaSektor', index).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4" v-if="dataJumlahKeluargaSektorKosong > 0">
                          <card
                            title="Belum Terisi"
                            :value="dataJumlahKeluargaSektorKosong"
                            :percentage="getComparisonDisplay('dataJumlahKeluargaSektorKosong', dataJumlahKeluargaSektorKosong).percentage"
                            :percentageColor="getComparisonDisplay('dataJumlahKeluargaSektorKosong', dataJumlahKeluargaSektorKosong).percentageColor"
                            :detail="getComparisonDisplay('dataJumlahKeluargaSektorKosong', dataJumlahKeluargaSektorKosong).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Baptis Section -->
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Baptis & Sidi
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Baptis Dewasa"
                            :value="dataBaptisDewasa"
                            :percentage="getComparisonDisplay('dataBaptisDewasa', dataBaptisDewasa).percentage"
                            :percentageColor="getComparisonDisplay('dataBaptisDewasa', dataBaptisDewasa).percentageColor"
                            :detail="getComparisonDisplay('dataBaptisDewasa', dataBaptisDewasa).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Baptis Anak"
                            :value="dataBaptisAnak"
                            :percentage="getComparisonDisplay('dataBaptisAnak', dataBaptisAnak).percentage"
                            :percentageColor="getComparisonDisplay('dataBaptisAnak', dataBaptisAnak).percentageColor"
                            :detail="getComparisonDisplay('dataBaptisAnak', dataBaptisAnak).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Sidi"
                            :value="dataSidi"
                            :percentage="getComparisonDisplay('dataSidi', dataSidi).percentage"
                            :percentageColor="getComparisonDisplay('dataSidi', dataSidi).percentageColor"
                            :detail="getComparisonDisplay('dataSidi', dataSidi).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <!-- Data Usia Section -->
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Usia
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia < 6"
                            :value="dataUmur06"
                            :percentage="getComparisonDisplay('dataUmur06', dataUmur06).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur06', dataUmur06).percentageColor"
                            :detail="getComparisonDisplay('dataUmur06', dataUmur06).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 6 - < 12"
                            :value="dataUmur612"
                            :percentage="getComparisonDisplay('dataUmur612', dataUmur612).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur612', dataUmur612).percentageColor"
                            :detail="getComparisonDisplay('dataUmur612', dataUmur612).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 12 - < 15"
                            :value="dataUmur1215"
                            :percentage="getComparisonDisplay('dataUmur1215', dataUmur1215).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur1215', dataUmur1215).percentageColor"
                            :detail="getComparisonDisplay('dataUmur1215', dataUmur1215).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 15 - < 18"
                            :value="dataUmur1518"
                            :percentage="getComparisonDisplay('dataUmur1518', dataUmur1518).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur1518', dataUmur1518).percentageColor"
                            :detail="getComparisonDisplay('dataUmur1518', dataUmur1518).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 18 - < 24"
                            :value="dataUmur1824"
                            :percentage="getComparisonDisplay('dataUmur1824', dataUmur1824).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur1824', dataUmur1824).percentageColor"
                            :detail="getComparisonDisplay('dataUmur1824', dataUmur1824).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 24 - < 30"
                            :value="dataUmur2430"
                            :percentage="getComparisonDisplay('dataUmur2430', dataUmur2430).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur2430', dataUmur2430).percentageColor"
                            :detail="getComparisonDisplay('dataUmur2430', dataUmur2430).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 30 - < 60"
                            :value="dataUmur3060"
                            :percentage="getComparisonDisplay('dataUmur3060', dataUmur3060).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur3060', dataUmur3060).percentageColor"
                            :detail="getComparisonDisplay('dataUmur3060', dataUmur3060).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 60 - < 70"
                            :value="dataUmur6070"
                            :percentage="getComparisonDisplay('dataUmur6070', dataUmur6070).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur6070', dataUmur6070).percentageColor"
                            :detail="getComparisonDisplay('dataUmur6070', dataUmur6070).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia > 70"
                            :value="dataUmur70"
                            :percentage="getComparisonDisplay('dataUmur70', dataUmur70).percentage"
                            :percentageColor="getComparisonDisplay('dataUmur70', dataUmur70).percentageColor"
                            :detail="getComparisonDisplay('dataUmur70', dataUmur70).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak (0-12)"
                            :value="dataUmurAnak"
                            :percentage="getComparisonDisplay('dataUmurAnak', dataUmurAnak).percentage"
                            :percentageColor="getComparisonDisplay('dataUmurAnak', dataUmurAnak).percentageColor"
                            :detail="getComparisonDisplay('dataUmurAnak', dataUmurAnak).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Pra-Remaja (13-15)"
                            :value="dataUmurPraRemaja"
                            :percentage="getComparisonDisplay('dataUmurPraRemaja', dataUmurPraRemaja).percentage"
                            :percentageColor="getComparisonDisplay('dataUmurPraRemaja', dataUmurPraRemaja).percentageColor"
                            :detail="getComparisonDisplay('dataUmurPraRemaja', dataUmurPraRemaja).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Remaja (16-17)"
                            :value="dataUmurRemaja"
                            :percentage="getComparisonDisplay('dataUmurRemaja', dataUmurRemaja).percentage"
                            :percentageColor="getComparisonDisplay('dataUmurRemaja', dataUmurRemaja).percentageColor"
                            :detail="getComparisonDisplay('dataUmurRemaja', dataUmurRemaja).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Pemuda (18+)"
                            :value="dataPemuda"
                            :percentage="getComparisonDisplay('dataPemuda', dataPemuda).percentage"
                            :percentageColor="getComparisonDisplay('dataPemuda', dataPemuda).percentageColor"
                            :detail="getComparisonDisplay('dataPemuda', dataPemuda).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Belum Terisi"
                            :value="dataUmurKosong"
                            :percentage="getComparisonDisplay('dataUmurKosong', dataUmurKosong).percentage"
                            :percentageColor="getComparisonDisplay('dataUmurKosong', dataUmurKosong).percentageColor"
                            :detail="getComparisonDisplay('dataUmurKosong', dataUmurKosong).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Kaum Bapak / Ibu Section -->
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Kaum Bapak / Ibu
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Kaum Bapak"
                            :value="dataKaumBapak"
                            :percentage="getComparisonDisplay('dataKaumBapak', dataKaumBapak).percentage"
                            :percentageColor="getComparisonDisplay('dataKaumBapak', dataKaumBapak).percentageColor"
                            :detail="getComparisonDisplay('dataKaumBapak', dataKaumBapak).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Kaum Ibu"
                            :value="dataKaumIbu"
                            :percentage="getComparisonDisplay('dataKaumIbu', dataKaumIbu).percentage"
                            :percentageColor="getComparisonDisplay('dataKaumIbu', dataKaumIbu).percentageColor"
                            :detail="getComparisonDisplay('dataKaumIbu', dataKaumIbu).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak Laki-Laki"
                            :value="dataAnakL"
                            :percentage="getComparisonDisplay('dataAnakL', dataAnakL).percentage"
                            :percentageColor="getComparisonDisplay('dataAnakL', dataAnakL).percentageColor"
                            :detail="getComparisonDisplay('dataAnakL', dataAnakL).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak Perempuan"
                            :value="dataAnakP"
                            :percentage="getComparisonDisplay('dataAnakP', dataAnakP).percentage"
                            :percentageColor="getComparisonDisplay('dataAnakP', dataAnakP).percentageColor"
                            :detail="getComparisonDisplay('dataAnakP', dataAnakP).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data KK Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data KK
                      </p>
                      <div class="row">
                        <div class="col-lg-6">
                          <card
                            title="KK Tambah"
                            :value="dataKeluargaMasuk"
                            :percentage="getComparisonDisplay('dataKeluargaMasuk', dataKeluargaMasuk).percentage"
                            :percentageColor="getComparisonDisplay('dataKeluargaMasuk', dataKeluargaMasuk).percentageColor"
                            :detail="getComparisonDisplay('dataKeluargaMasuk', dataKeluargaMasuk).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="KK Keluar"
                            :value="dataKeluargaKeluar"
                            :percentage="getComparisonDisplay('dataKeluargaKeluar', dataKeluargaKeluar).percentage"
                            :percentageColor="getComparisonDisplay('dataKeluargaKeluar', dataKeluargaKeluar).percentageColor"
                            :detail="getComparisonDisplay('dataKeluargaKeluar', dataKeluargaKeluar).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="Anggota Lahir"
                            :value="dataLahirTahunIni"
                            :percentage="getComparisonDisplay('dataLahirTahunIni', dataLahirTahunIni).percentage"
                            :percentageColor="getComparisonDisplay('dataLahirTahunIni', dataLahirTahunIni).percentageColor"
                            :detail="getComparisonDisplay('dataLahirTahunIni', dataLahirTahunIni).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="Anggota Meninggal"
                            :value="dataMeninggalTahunIni"
                            :percentage="getComparisonDisplay('dataMeninggalTahunIni', dataMeninggalTahunIni).percentage"
                            :percentageColor="getComparisonDisplay('dataMeninggalTahunIni', dataMeninggalTahunIni).percentageColor"
                            :detail="getComparisonDisplay('dataMeninggalTahunIni', dataMeninggalTahunIni).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Data Status Perkawinan Section -->
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Status Perkawinan
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Duda"
                            :value="dataDuda"
                            :percentage="getComparisonDisplay('dataDuda', dataDuda).percentage"
                            :percentageColor="getComparisonDisplay('dataDuda', dataDuda).percentageColor"
                            :detail="getComparisonDisplay('dataDuda', dataDuda).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Janda"
                            :value="dataJanda"
                            :percentage="getComparisonDisplay('dataJanda', dataJanda).percentage"
                            :percentageColor="getComparisonDisplay('dataJanda', dataJanda).percentageColor"
                            :detail="getComparisonDisplay('dataJanda', dataJanda).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Hidup Sendiri"
                            :value="dataSendiri"
                            :percentage="getComparisonDisplay('dataSendiri', dataSendiri).percentage"
                            :percentageColor="getComparisonDisplay('dataSendiri', dataSendiri).percentageColor"
                            :detail="getComparisonDisplay('dataSendiri', dataSendiri).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <!-- Data Peran Keluarga Section -->
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Peran Keluarga
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Pasangan"
                            :value="dataPasangan"
                            :percentage="getComparisonDisplay('dataPasangan', dataPasangan).percentage"
                            :percentageColor="getComparisonDisplay('dataPasangan', dataPasangan).percentageColor"
                            :detail="getComparisonDisplay('dataPasangan', dataPasangan).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Anak"
                            :value="dataAnak"
                            :percentage="getComparisonDisplay('dataAnak', dataAnak).percentage"
                            :percentageColor="getComparisonDisplay('dataAnak', dataAnak).percentageColor"
                            :detail="getComparisonDisplay('dataAnak', dataAnak).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Saudara"
                            :value="dataSaudara"
                            :percentage="getComparisonDisplay('dataSaudara', dataSaudara).percentage"
                            :percentageColor="getComparisonDisplay('dataSaudara', dataSaudara).percentageColor"
                            :detail="getComparisonDisplay('dataSaudara', dataSaudara).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Orang Tua"
                            :value="dataOrangTua"
                            :percentage="getComparisonDisplay('dataOrangTua', dataOrangTua).percentage"
                            :percentageColor="getComparisonDisplay('dataOrangTua', dataOrangTua).percentageColor"
                            :detail="getComparisonDisplay('dataOrangTua', dataOrangTua).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Menantu"
                            :value="dataMenantu"
                            :percentage="getComparisonDisplay('dataMenantu', dataMenantu).percentage"
                            :percentageColor="getComparisonDisplay('dataMenantu', dataMenantu).percentageColor"
                            :detail="getComparisonDisplay('dataMenantu', dataMenantu).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Cucu"
                            :value="dataCucu"
                            :percentage="getComparisonDisplay('dataCucu', dataCucu).percentage"
                            :percentageColor="getComparisonDisplay('dataCucu', dataCucu).percentageColor"
                            :detail="getComparisonDisplay('dataCucu', dataCucu).detail"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Lainnya"
                            :value="dataLainnya"
                            :percentage="getComparisonDisplay('dataLainnya', dataLainnya).percentage"
                            :percentageColor="getComparisonDisplay('dataLainnya', dataLainnya).percentageColor"
                            :detail="getComparisonDisplay('dataLainnya', dataLainnya).detail"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading State -->
        <div v-if="loading" class="row">
          <div class="col-12 text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-2">Memuat data laporan...</p>
          </div>
        </div>

        <!-- Error State -->
        <div v-if="error" class="row">
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
              <h4 class="alert-heading">Error!</h4>
              <p>{{ error }}</p>
              <button @click="fetchLaporanData" class="btn btn-outline-danger">
                Coba Lagi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/examples/Cards/Card.vue";

export default {
  name: "LaporanPage",
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      availableYears: [],
      loading: false,
      error: null,
      
      // Current year data
      dataJemaat: 0,
      dataJemaatL: 0,
      dataJemaatP: 0,
      dataKK: 0,
      dataTitipan: 0,
      dataDisabilitas: 0,
      dataPindahanDariKristen: 0,
      dataPindahanKeKristen: 0,
      dataUmur06: 0,
      dataUmur612: 0,
      dataUmur1215: 0,
      dataUmur1518: 0,
      dataUmur1824: 0,
      dataUmur2430: 0,
      dataUmur3060: 0,
      dataUmur6070: 0,
      dataUmur70: 0,
      dataUmurAnak: 0,
      dataUmurPraRemaja: 0,
      dataUmurRemaja: 0,
      dataPemuda: 0,
      dataKaumBapak: 0,
      dataKaumIbu: 0,
      dataDuda: 0,
      dataJanda: 0,
      dataSendiri: 0,
      dataUmurKosong: 0,
      dataAnakL: 0,
      dataAnakP: 0,
      dataKeluargaKeluar: 0,
      dataKeluargaMasuk: 0,
      dataLahirTahunIni: 0,
      dataMeninggalTahunIni: 0,
      
      // Family role data
      dataPasangan: 0,
      dataAnak: 0,
      dataSaudara: 0,
      dataOrangTua: 0,
      dataMenantu: 0,
      dataCucu: 0,
      dataLainnya: 0,
      
      // Baptis data
      dataBaptisDewasa: 0,
      dataBaptisAnak: 0,
      dataSidi: 0,
      
      // Wilayah and Sektor data
      dataJumlahWilayah: [],
      dataJumlahSektor: [],
      dataJumlahKeluargaWilayah: [],
      dataJumlahKeluargaSektor: [],
      dataJumlahWilayahKosong: 0,
      dataJumlahSektorKosong: 0,
      dataJumlahKeluargaWilayahKosong: 0,
      dataJumlahKeluargaSektorKosong: 0,
      
      // Previous year data for comparison
      previousYearData: {}
    };
  },
  methods: {
    /**
     * Fetch available years from API
     */
    async fetchAvailableYears() {
      try {
        const response = await this.axios.get(
          process.env.VUE_APP_API_URL + "laporan/available-years"
        );
        
        // Check if API response is successful
        if (response.data.status) {
          this.availableYears = response.data.years || [];
        } else {
          console.error("API Error:", response.data.message);
          this.availableYears = [new Date().getFullYear()];
        }
        
        // Set selected year to the latest available year
        if (this.availableYears.length > 0) {
          this.selectedYear = Math.max(...this.availableYears);
        }
      } catch (error) {
        console.error("Error fetching available years:", error);
        // Fallback to current year if API fails
        this.availableYears = [new Date().getFullYear()];
        this.selectedYear = new Date().getFullYear();
      }
    },
    
    /**
     * Fetch comparison data for selected year
     */
    async fetchLaporanData() {
      if (!this.selectedYear) return;
      
      this.loading = true;
      this.error = null;
      
      try {
        const response = await this.axios.get(
          process.env.VUE_APP_API_URL + "laporan/comparison",
          {
            params: { year: this.selectedYear }
          }
        );
        
        // Check if API response is successful
        if (response.data.status) {
          const data = {
            currentYear: response.data.current_data,
            previousYear: response.data.previous_data
          };
          this.processLaporanData(data);
        } else {
          console.error("API Error:", response.data.message);
          this.error = response.data.message || "Gagal memuat data laporan.";
        }
      } catch (error) {
        console.error("Error fetching laporan data:", error);
        this.error = "Gagal memuat data laporan. Silakan coba lagi.";
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * Process the response data and update component properties
     */
    processLaporanData(data) {
      // Current year data
      const currentData = data.currentYear || {};
      this.dataJemaat = currentData.dataJemaat || 0;
      this.dataJemaatL = currentData.dataJemaatL || 0;
      this.dataJemaatP = currentData.dataJemaatP || 0;
      this.dataKK = currentData.dataKK || 0;
      this.dataTitipan = currentData.dataTitipan || 0;
      this.dataDisabilitas = currentData.dataDisabilitas || 0;
      this.dataPindahanDariKristen = currentData.dataPindahanDariKristen || 0;
      this.dataPindahanKeKristen = currentData.dataPindahanKeKristen || 0;
      
      // Age data
      const ageData = currentData.dataUmur || {};
      this.dataUmur06 = ageData["0-5"] || 0;
      this.dataUmur612 = ageData["6-11"] || 0;
      this.dataUmur1215 = ageData["12-14"] || 0;
      this.dataUmur1518 = ageData["15-17"] || 0;
      this.dataUmur1824 = ageData["18-23"] || 0;
      this.dataUmur2430 = ageData["24-29"] || 0;
      this.dataUmur3060 = ageData["30-59"] || 0;
      this.dataUmur6070 = ageData["60-69"] || 0;
      this.dataUmur70 = ageData["70+"] || 0;
      this.dataUmurKosong = ageData[""] || 0;
      
      // Classification data
      const classificationData = currentData.dataKlasifikasi || {};
      this.dataUmurAnak = classificationData["0-12"] || 0;
      this.dataUmurPraRemaja = classificationData["13-15"] || 0;
      this.dataUmurRemaja = classificationData["16-17"] || 0;
      this.dataPemuda = classificationData["18+"] || 0;
      
      // Other data
      this.dataKaumBapak = currentData.dataKaumBapak || 0;
      this.dataKaumIbu = currentData.dataKaumIbu || 0;
      this.dataAnakL = currentData.dataAnakL || 0;
      this.dataAnakP = currentData.dataAnakP || 0;
      this.dataKeluargaKeluar = currentData.dataKeluargaKeluar || 0;
      this.dataKeluargaMasuk = currentData.dataKeluargaMasuk || 0;
      this.dataLahirTahunIni = currentData.dataLahirTahunIni || 0;
      this.dataMeninggalTahunIni = currentData.dataMeninggalTahunIni || 0;
      this.dataDuda = currentData.dataDuda || 0;
      this.dataJanda = currentData.dataJanda || 0;
      this.dataSendiri = currentData.dataSendiri || 0;
      
      // Family role data
      this.dataPasangan = currentData.dataPasangan || 0;
      this.dataAnak = currentData.dataAnak || 0;
      this.dataSaudara = currentData.dataSaudara || 0;
      this.dataOrangTua = currentData.dataOrangTua || 0;
      this.dataMenantu = currentData.dataMenantu || 0;
      this.dataCucu = currentData.dataCucu || 0;
      this.dataLainnya = currentData.dataLainnya || 0;
      
      // Baptis data
      this.dataBaptisDewasa = currentData.dataBaptisDewasa || 0;
      this.dataBaptisAnak = currentData.dataBaptisAnak || 0;
      this.dataSidi = currentData.dataSidi || 0;
      
      // Wilayah and Sektor data
      this.dataJumlahWilayah = currentData.dataJumlahWilayah || [];
      this.dataJumlahSektor = currentData.dataJumlahSektor || [];
      this.dataJumlahKeluargaWilayah = currentData.dataJumlahKeluargaWilayah || [];
      this.dataJumlahKeluargaSektor = currentData.dataJumlahKeluargaSektor || [];
      this.dataJumlahWilayahKosong = currentData.dataJumlahWilayahKosong || 0;
      this.dataJumlahSektorKosong = currentData.dataJumlahSektorKosong || 0;
      this.dataJumlahKeluargaWilayahKosong = currentData.dataJumlahKeluargaWilayahKosong || 0;
      this.dataJumlahKeluargaSektorKosong = currentData.dataJumlahKeluargaSektorKosong || 0;
      
      // Store previous year data for comparison
      this.previousYearData = data.previousYear || {};
    },
    
    /**
     * Get comparison data for a specific field
     */
    getComparison(fieldName) {
      if (!this.previousYearData || Object.keys(this.previousYearData).length === 0) {
        return null;
      }
      
      let previousValue = 0;
      
      // Handle nested data structures
      if (fieldName.startsWith('dataUmur') && fieldName !== 'dataUmurKosong') {
        const ageRanges = {
          'dataUmur06': '0-5',
          'dataUmur612': '6-11',
          'dataUmur1215': '12-14',
          'dataUmur1518': '15-17',
          'dataUmur1824': '18-23',
          'dataUmur2430': '24-29',
          'dataUmur3060': '30-59',
          'dataUmur6070': '60-69',
          'dataUmur70': '70+',
          'dataUmurAnak': '0-12',
          'dataUmurPraRemaja': '13-15',
          'dataUmurRemaja': '16-17',
          'dataPemuda': '18+'
        };
        
        if (fieldName === 'dataUmurKosong') {
          previousValue = (this.previousYearData.dataUmur && this.previousYearData.dataUmur[""]) || 0;
        } else if (['dataUmurAnak', 'dataUmurPraRemaja', 'dataUmurRemaja', 'dataPemuda'].includes(fieldName)) {
          previousValue = (this.previousYearData.dataKlasifikasi && this.previousYearData.dataKlasifikasi[ageRanges[fieldName]]) || 0;
        } else {
          previousValue = (this.previousYearData.dataUmur && this.previousYearData.dataUmur[ageRanges[fieldName]]) || 0;
        }
      } else {
        previousValue = this.previousYearData[fieldName] || 0;
      }
      
      return {
        previousValue: previousValue,
        previousYear: this.selectedYear - 1
      };
    },
    
    /**
     * Get formatted comparison display for cards
     */
    getComparisonDisplay(fieldName, currentValue) {
      const comparison = this.getComparison(fieldName);
      if (!comparison) {
        return {
          percentage: '',
          percentageColor: 'text-muted',
          detail: ''
        };
      }
      
      const previousValue = comparison.previousValue;
      const safeCurrentValue = currentValue || 0;
      const difference = safeCurrentValue - previousValue;
      const percentageChange = previousValue > 0 ? ((difference / previousValue) * 100) : 0;
      
      const isIncrease = difference > 0;
      const arrow = isIncrease ? '↑' : (difference < 0 ? '↓' : '→');
      const color = isIncrease ? 'text-success' : (difference < 0 ? 'text-danger' : 'text-muted');
      
      return {
        percentage: `${arrow} ${Math.abs(percentageChange).toFixed(1)}%`,
        percentageColor: color,
        detail: `(${difference >= 0 ? '+' : ''}${difference})`
      };
    },
    
    /**
     * Get comparison display for wilayah data arrays
     * @param {string} dataKey - The data key to compare
     * @param {number} index - The index of the wilayah item
     * @returns {object} Comparison display object
     */
    getWilayahComparisonDisplay(dataKey, index) {
      const currentValue = this[dataKey][index]?.TOTAL || 0;
      const previousValue = this.previousYearData[dataKey]?.[index]?.TOTAL || 0;
      
      if (previousValue === 0 || isNaN(previousValue)) {
        return {
          percentage: currentValue > 0 ? '↑ +100%' : '→ 0%',
          percentageColor: currentValue > 0 ? 'text-success' : 'text-muted',
          detail: 'Data tahun sebelumnya tidak tersedia'
        };
      }
      
      const difference = currentValue - previousValue;
      const percentageChange = isNaN(difference) || isNaN(previousValue) ? 0 : ((difference / previousValue) * 100).toFixed(1);
      const arrow = difference > 0 ? '↑' : (difference < 0 ? '↓' : '→');
      const color = difference > 0 ? 'text-success' : (difference < 0 ? 'text-danger' : 'text-muted');
      
      return {
        percentage: `${arrow} ${Math.abs(percentageChange)}%`,
        percentageColor: color,
        detail: `(${difference >= 0 ? '+' : ''}${difference})`
      };
    },
    
    /**
     * Get comparison display for sektor data arrays
     * @param {string} dataKey - The data key to compare
     * @param {number} index - The index of the sektor item
     * @returns {object} Comparison display object
     */
    getSektorComparisonDisplay(dataKey, index) {
      const currentValue = this[dataKey][index]?.TOTAL || 0;
      const previousValue = this.previousYearData[dataKey]?.[index]?.TOTAL || 0;
      
      if (previousValue === 0 || isNaN(previousValue)) {
        return {
          percentage: currentValue > 0 ? '↑ +100%' : '→ 0%',
          percentageColor: currentValue > 0 ? 'text-success' : 'text-muted',
          detail: 'Data tahun sebelumnya tidak tersedia'
        };
      }
      
      const difference = currentValue - previousValue;
      const percentageChange = isNaN(difference) || isNaN(previousValue) ? 0 : ((difference / previousValue) * 100).toFixed(1);
      const arrow = difference > 0 ? '↑' : (difference < 0 ? '↓' : '→');
      const color = difference > 0 ? 'text-success' : (difference < 0 ? 'text-danger' : 'text-muted');
      
      return {
        percentage: `${arrow} ${Math.abs(percentageChange)}%`,
        percentageColor: color,
        detail: `(${difference >= 0 ? '+' : ''}${difference})`
      };
    }
  },
  async created() {
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
    await this.fetchAvailableYears();
    await this.fetchLaporanData();
  },
  mounted() {
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
  },
  beforeUnmount() {
    this.$store.state.showSidenav = true;
    this.$store.state.showNavbar = true;
  },
  components: {
    Card
  }
};
</script>

<style scoped>
.laporan-container {
  background: linear-gradient(135deg, #2dce89 0%, #2dcecc 100%);
  min-height: 100vh;
  padding-top: 0;
  padding-bottom: 2rem;
  margin-top: 0;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.95);
}

.alert {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

h2 {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 2.5rem;
}

@media (max-width: 768px) {
  h2 {
    font-size: 2rem;
  }
}
</style>